import script from "./YourAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./YourAccount.vue?vue&type=script&setup=true&lang=js"

import "./YourAccount.vue?vue&type=style&index=0&id=e8f899a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8f899a6"]])

export default __exports__